import Clutch from '@/components/SvgIcons/Socials/Clutch';
import { ReviewPlatform } from '@/types/profile.type';

const clutchCompanyId = 'f9e2dbe8-7402-4aa0-82b7-12d0d3b66869';

export const getClutchReviewUrl = (reviewId: string): string =>
  `https://clutch.co/go-to-review/${clutchCompanyId}/${reviewId}`;

// `satisfies` keeps the literal fields typed, so consumers read rating and reviewCount without undefined checks
export const clutchPlatform = {
  name: 'Clutch',
  profileUrl: 'https://clutch.co/profile/workspace-0',
  rating: 5,
  reviewCount: 28,
  socialIcon: Clutch,
} satisfies ReviewPlatform;

const techBehemothsPlatform = {
  name: 'TechBehemoths',
  profileUrl: 'https://techbehemoths.com/company/workspace',
  verifiedLink: true,
} satisfies ReviewPlatform;

export const reviewPlatforms: ReviewPlatform[] = [clutchPlatform, techBehemothsPlatform];
